/**
 * A safe href for a user-typed link, or null when it shouldn't be linked.
 *
 * People often paste `example.com/page` without a scheme; left alone the
 * browser would resolve that relative to the app, so assume https. Only
 * http(s) is linked: sources can come from other people's shared POIs, and a
 * `javascript:` href must never reach an anchor.
 */
export function externalHref(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;
  const candidate = /^[a-z][a-z\d+.-]*:/i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
  try {
    const parsed = new URL(candidate);
    return parsed.protocol === "http:" || parsed.protocol === "https:"
      ? parsed.href
      : null;
  } catch {
    return null;
  }
}

/** Short label for a link: its host without a leading `www.`. */
export function linkHost(href: string): string {
  try {
    return new URL(href).hostname.replace(/^www\./, "");
  } catch {
    return href;
  }
}
